export const staticUrls = {
  parentDefault: 'https://assets.urbansitter.com/static/img/flower/family-default.webp',
  caregiver1: 'https://assets.urbansitter.com/static/img/flower/caregiver-christina.webp',
  caregiver2: 'https://assets.urbansitter.com/static/img/flower/caregiver-ben.webp',
  caregiver3: 'https://assets.urbansitter.com/static/img/flower/caregiver-caitlin.webp',
  caregiver4: 'https://assets.urbansitter.com/static/img/flower/caregiver-rebekah.webp',
  caregiver5: 'https://assets.urbansitter.com/static/img/flower/caregiver-ziwase.webp',
  caregiver6: 'https://assets.urbansitter.com/static/img/flower/caregiver-poppy.webp',
  familyTestimonal: 'https://assets.urbansitter.com/static/img/flower/family-testimonal.webp'
};
